import { render, staticRenderFns } from "./ViewFeeReceipt.vue?vue&type=template&id=93e71d70&scoped=true&"
import script from "./ViewFeeReceipt.vue?vue&type=script&lang=js&"
export * from "./ViewFeeReceipt.vue?vue&type=script&lang=js&"
import style0 from "./ViewFeeReceipt.vue?vue&type=style&index=0&id=93e71d70&media=print&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93e71d70",
  null
  
)

export default component.exports